import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Brain, Eye, Footprints } from 'lucide-react';
import { Button } from './ui/Button';
export function Timeline21Days() {
  const phases = [{
    days: 'Días 1–7',
    title: 'Reprogramación',
    desc: 'Creencias + afirmaciones',
    icon: Brain,
    color: 'bg-purple-100 text-purple-600'
  }, {
    days: 'Días 8–14',
    title: 'Visualización',
    desc: 'Vision board + rutina AM/PM + escena perfecta',
    icon: Eye,
    color: 'bg-blue-100 text-blue-600'
  }, {
    days: 'Días 15–21',
    title: 'Acción inspirada',
    desc: 'Acciones diarias + señales + celebrar avances',
    icon: Footprints,
    color: 'bg-amber-100 text-amber-600'
  }];
  return <section className="py-12 px-4 bg-[#F8F3EA]" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B0A3D] mb-4" data-id="element-193">
            Plan de 21 Días
          </h2>
          <p className="text-gray-600" data-id="element-194">
            Un viaje estructurado para transformar tu realidad
          </p>
        </div>

        <div className="relative" data-id="element-195">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-200 -translate-y-1/2 z-0" data-id="element-196"></div>

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-197">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center group hover:-translate-y-2 transition-transform duration-300" data-id="element-198">
                <div className={`w-16 h-16 rounded-full ${phase.color} flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform`} data-id="element-199">
                  <phase.icon className="w-8 h-8" data-id="element-200" />
                </div>
                <span className="inline-block px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold rounded-full mb-3" data-id="element-201">
                  {phase.days}
                </span>
                <h3 className="text-xl font-bold text-[#2B0A3D] mb-2" data-id="element-202">
                  {phase.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-203">{phase.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-204">
          <Button scrollTo="oferta" variant="outline" className="group" data-id="element-205">
            Quiero mi plan de 21 días
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-206" />
          </Button>
        </div>
      </div>
    </section>;
}